import React from "react";
import type { GroupBase, MenuListProps } from "react-select";
import { FixedSizeList as List } from "react-window";

import type { SelectOption } from "@winshop-crm/types";

const height = 36;

/** Virtualized react-select menu (react-window); companies list has thousands of rows. */
const SelectMenuList = (props: MenuListProps<SelectOption, boolean, GroupBase<SelectOption>>) => {
  const { options, children, maxHeight, getValue } = props;
  const [value] = getValue();
  const initialOffset = options.findIndex((option) => option === value) * height;
  const items = React.Children.toArray(children);

  return (
    <List
      width="100%"
      height={maxHeight}
      itemCount={items.length}
      itemSize={height}
      initialScrollOffset={initialOffset}
    >
      {({ index, style }) => <div style={style}>{items[index]}</div>}
    </List>
  );
};

export default SelectMenuList;
